import { NgModule } from '@angular/core';
import { OAuthModule } from 'angular-oauth2-oidc';
import { authConfigLMSProvider, OAuthModuleConfig, AuthLSMConfig } from './auth.config';
import { IdentificationLMSProviderService } from './identification-lms-provider.service';

@NgModule({
  imports: [
    OAuthModule.forRoot(),
  ],
  providers: [
    { provide: AuthLSMConfig, useFactory: authConfigLMSProvider },
    OAuthModuleConfig,
    IdentificationLMSProviderService
  ]
})
export class AuthLMSModule { }
